module.exports = __webpack_public_path__ + "static/media/image_21.0e43b0c8.png";